<div class="our-story-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="our-story-title">
                    <h3><span class="number level-title">1</span> L'école s'inspire du texte de Actes 19: 8-10
                    </h3>
                </div>
            </div>

            <div class="col-md-12" style="margin-top:22px">
                <div class="our-story-content">
                    <p><strong>8.</strong> Ensuite Paul entra dans la synagogue, où il parla librement. Pendant trois
                        mois,
                        il
                        discourut sur
                        les choses qui concernent le royaume de Dieu, s'efforçant de persuader ceux qui l'écoutaient.
                        <strong>9.</strong> Mais, comme quelques-uns restaient endurcis et incrédules, décriant devant
                        la
                        multitude la voie du
                        Seigneur, il se retira d'eux, sépara les disciples, et enseigna chaque jour dans l'école d'un
                        nommé
                        Tyrannus.
                        <strong>10.</strong> Cela dura deux ans, de sorte que tous ceux qui habitaient l'Asie, Juifs et
                        Grecs,
                        entendirent la
                        parole du Seigneur.
                    </p>
                </div>
            </div>
            <div class="col-lg-12 col-md-12" style="margin-top:35px">
                <div class="our-story-title">
                    <h3><span class="number level-title">2</span> Une vision</h3>
                </div>
            </div>
            <div class="col-lg-8 col-md-12" style="margin-top:22px">
                <div class="our-story-content">
                    <p>Notre école tire sa source du texte de Actes 19 verset 8-10.
                        Notre vision est de faire des élèves une source de bénédictions pour les familles et les
                        nations.</p>
                </div>
            </div>

            <!-- <div class="col-lg-12 col-md-12">
                <div class="our-story-image">
                    <img src="assets/img/mission.png" alt="image">
                </div>
            </div> -->
            <div class="col-md-12" style="margin-top:45px">
                <div class="our-story-title">
                    <h3><span class="number level-title">3</span> Un mot sur l'école</h3>
                </div>
            </div>
            <div class="col-md-12" style="margin-top:22px">
                <div class="our-story-content">

                    <p>Eulogia est une école biblique en ligne, proposant une formation payante et certifiante sur une
                        durée
                        d'un an. Les cours dispensés se concentrent sur une analyse approfondie de la Bible, abordant
                        son contexte historique et son impact contemporain face aux défis cruciaux de la vie quotidienne
                        des chrétiens.

                        Cette institution, fondée en 2019, résulte d'une collaboration fructueuse entre l'église locale
                        des Ministères CIEL, dirigée par le couple pastoral Cyrille et Laurence Ndong, et l'école Pneuma
                        Global Family, sous la direction de l'Apôtre Suresh GUNHA.</p>
                </div>
            </div>
        </div>
    </div>
</div>